module.exports = __webpack_public_path__ + "static/euforia1-6574e226f98f145fe94b604b34823d8c.png";